<template>
    <div>
        <div v-if="select_skuInfo_list && select_skuInfo_list.length > 0"
             style="position: fixed; right: -1px; bottom: 130px">
            <Badge :count="select_skuInfo_list.length" style="position: absolute;"></Badge>
            <van-button
                    style="margin-left: 9px; margin-top: 9px;"
                    type="info"
                    @click="showSelectList"
            >选品清单
            </van-button>
        </div>

        <!--选品清单sheet-->
        <JdSelectListSheet ref="jdSelectListSheet"></JdSelectListSheet>

    </div>
</template>

<script>
    import JdSelectListSheet from "./JdSelectListSheet";
    export default {
        name: "Wp_select_list_mark_model",
        components: {JdSelectListSheet},
        provide() {
            return {
                JdSelectListMark: this
            }
        },

        data(){
            return{
                //选品清单，内容为skuId
                select_skuId_list: [],
                //选品清单中的商品信息集合
                select_skuInfo_list: [],

                //添加到选品清单中的商品数量上限
                select_sku_length_limit: 9,
            }
        },

        methods:{
            /**
             * 显示商品清单
             */
            showSelectList() {
                // this.getSelectSkuList();
                if (this.select_skuInfo_list && this.select_skuInfo_list.length > 0) {
                    // this.showSelect = true;
                    this.$refs.jdSelectListSheet.showSelect = true;
                }
            },


            /**
             * 添加商品到选品清单中
             */
            addInSelectList(skuInfo, skuId) {
                if (this.select_skuInfo_list.length === this.select_sku_length_limit) {
                    this.$dialog.alert({
                        message: '[选品清单]以达到最大限额'
                    });
                    return;
                }

                if (this.select_skuId_list.includes(skuId)) {
                    // this.$toast.fail("该商品已加入[选品清单]")
                    this.$dialog.alert({
                        message: '该商品已加入[选品清单]'
                    });
                } else {
                    this.select_skuInfo_list.push(skuInfo)
                    this.select_skuId_list.push(skuId)
                }
            },

            releaseSelectData(){
                this.$refs.jdSelectListSheet.releaseSelectData();
            }
        }
    }
</script>

<style scoped>

</style>